import { formatNumeric } from '@helpers/data'
import { useStyles } from '@hooks/useStyles'
import { Paragraph, Text } from '@ui-kit'
import { getVariant, isUnlimited } from '@ui-kit/LimitBar/helpers'
import { FC } from 'react'

import styles from './LimitBadge.module.scss'

interface LimitBadgeProps {
  quantity: number
  limit: number
}

export const LimitBadge: FC<LimitBadgeProps> = ({ quantity, limit }) => {
  const variant = isUnlimited(limit) ? 'progress' : getVariant(quantity, limit)
  const limitValue = isUnlimited(limit) ? ' / ∞' : ` / ${formatNumeric(limit)}`

  const badgeStyles = useStyles({
    [styles['limit-badge']]: true,
    [styles[`limit-badge--${variant}`]]: true
  })

  return (
    <div className={badgeStyles}>
      <Paragraph size={12} color='neutral-8' lineHeight='normal'>
        <Text weight={600} lineHeight='normal'>
          {formatNumeric(quantity)}
        </Text>{' '}
        {limitValue}
      </Paragraph>
    </div>
  )
}

LimitBadge.displayName = 'TopbarInfobarFreePlansLimitBadge'
